import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { Box, Button, Dialog, DialogActions, IconButton, Typography } from '@mui/material';
import React from 'react';

import { CONFIRMATION_MODAL } from '../../../../../constants/addressBook';

interface IProps {
  isOpen: boolean;
  onDiscardUpload: () => void;
  onCloseConfirmationModal: () => void;
}

const ConfirmationModal: React.FC<IProps> = ({ isOpen, onDiscardUpload, onCloseConfirmationModal }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onCloseConfirmationModal}
      sx={{
        '& .MuiDialog-paper': {
          width: 346,
          borderRadius: 0.5,
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
          },
        },
      }}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 1.5, pl: 3, pr: 2, py: 2 }}
      >
        <Box>
          <ErrorOutlineIcon sx={{ color: 'error.main' }} />
        </Box>
        <Box>
          <Typography variant="h6" sx={{ lineHeight: 1.4 }}>
            {CONFIRMATION_MODAL.title}
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.6, mt: 1 }}>
            {CONFIRMATION_MODAL.description}
          </Typography>
        </Box>
        <IconButton
          sx={{ alignSelf: 'flex-start', p: 0 }}
          aria-label="close"
          onClick={onCloseConfirmationModal}
          data-action="close_confirmation_modal_btn"
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogActions>
        <Button
          variant="text"
          color="primary"
          sx={{ color: 'error.main' }}
          onClick={onDiscardUpload}
          data-action="discard_upload_btn"
        >
          Discard upload
        </Button>
        <Button variant="contained" color="primary" onClick={onCloseConfirmationModal} data-action="keep_editing_btn">
          Keep editing
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
